import React from "react";

const Loader = ({ size = 80, color = "#0DD0D0", className = "" }) => {
  return (
    <div
      className={`d-flex align-items-center justify-content-center ${className}`}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="6" cy="50" r="6" fill={color}>
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 15; 0 -15; 0 15"
            repeatCount="indefinite"
            begin="0.1s"
          />
        </circle>

        <circle cx="30" cy="50" r="6" fill={color}>
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 10; 0 -10; 0 10"
            repeatCount="indefinite"
            begin="0.2s"
          />
        </circle>

        <circle cx="54" cy="50" r="6" fill={color}>
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 5; 0 -5; 0 5"
            repeatCount="indefinite"
            begin="0.3s"
          />
        </circle>
      </svg>
    </div>
  );
};

export default Loader;
